export default "__VITE_ASSET__D6YvW$_G__"